import CreateCampaign from '@/modules/campaign-manage/pages/CreateCampaign'
import { EventBus } from '@/core/EventBus'
import router from '@/core/router'
import CampaignReport from '@/modules/campaign-manage/pages/CampaignReport.vue'

export default [
  {
    name: 'UpdateCampaign',
    path: '/push/campaign/update',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'CopyCampaign',
    path: '/push/campaign/copy',
    component: CreateCampaign,
    meta: {
      auth: ['createProjectItem']
    }
  },
  {
    name: 'ViewCampaign',
    path: '/push/campaign/view',
    component: CreateCampaign,
    meta: {
      auth: ['viewProjectItem']
    }
  },
  {
    name: 'ViewCampaignSnapshot',
    path: '/push/campaign/snapshot',
    component: CreateCampaign,
    meta: {
      auth: ['AuditLog:ReadAccess']
    }
  },
  {
    name: 'CreateCampaign',
    path: '/push/campaign/create',
    component: CreateCampaign,
    meta: {
      action: toRoute => {
        if (router.currentRoute.name === toRoute.name) {
          EventBus.$emit('show-confirmation-before-create-dialog', toRoute)
        } else {
          EventBus.$emit('show-campaign-create-dialog', toRoute)
        }
      },
      avoid_action_query_params: ['type'],
      title: 'LeftNavigation_CreateCampaign',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'CampaignReport',
    path: '/push/campaign/report/create',
    component: CampaignReport,
    meta: {
      title: 'CampaignReport_Tab_Title',
      auth: ['exportCampaignAnalytics']
    }
  },
  {
    name: 'UpdateCampaignReport',
    path: '/push/campaign/report/update',
    component: CampaignReport,
    meta: {
      title: 'CampaignReport',
      auth: ['exportCampaignAnalytics']
    }
  },
  {
    name: 'CreateTemplateCampaign',
    path: '/push/campaign/template/create',
    component: CreateCampaign,
    meta: {
      action: toRoute => {
        if (router.currentRoute.name === toRoute.name) {
          EventBus.$emit('show-confirmation-before-create-dialog', toRoute)
        } else {
          EventBus.$emit('show-campaign-template-create-dialog', toRoute)
        }
      },
      avoid_action_query_params: ['type'],
      title: 'LeftNavigation_TemplateCampaigns',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'UpdateTemplateCampaign',
    path: '/push/campaign/template/update',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'CopyTemplateCampaign',
    path: '/push/campaign/template/copy',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'ViewTemplateCampaign',
    path: '/push/campaign/template/view',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'CreateFromTemplate',
    path: '/push/campaign/template/create-from',
    component: CreateCampaign,
    meta: {
      auth: ['createProjectItem']
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/router/index.js